"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormTitleSpacer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var FormTitleSpacer = _styledComponents.default.div.withConfig({
  displayName: "style__FormTitleSpacer",
  componentId: "e2ormj-0"
})(["padding-bottom:", ";@media (min-width:", "){padding-bottom:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.md;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.md;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.xxxl;
});
exports.FormTitleSpacer = FormTitleSpacer;